// extracted by mini-css-extract-plugin
export default {"content":"TrimSurfaces_content__o0DJv"};